import { __awaiter, __generator } from "tslib";
import { launchUrl } from '@office-start/launcher-service';
export function createOpenInBrowserAction(item) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!item.webUrl) {
                        return [2 /*return*/];
                    }
                    action = item.isEmailAttachment ? 'OpenAttachment' : 'OpenFile';
                    return [4 /*yield*/, launchUrl(item.webUrl, { action: action })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
//# sourceMappingURL=createOpenInBrowserAction.js.map